<template>
  <f7-popup class="AddContact">

		<page-nav-bar currentServiceName="MoneyRoad" subNavTitle="New Contact" :closePopup="true"></page-nav-bar>

    <div class="layoutSubtitle"/>
    <f7-list form>
      <f7-list-item>
        <f7-label>Account Name</f7-label>
        <f7-input name="label" type="text" placeholder="Label" v-model="label"></f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-label>User Name</f7-label>
        <f7-input name="username" placeholder="Name" type="text" v-model="username"></f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Identifier</f7-label>
        <f7-input name="alias" type="email" placeholder="Identifier" v-model="alias"></f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Iban</f7-label>
        <f7-input name="iban" type="text" placeholder="Iban" v-model="iban"></f7-input>
      </f7-list-item>
    </f7-list>
    <f7-button icon-f7="add_round" class="blueConfirmationButton" @click="addContact">Create</f7-button>
    <f7-button disabled icon-f7="cloud_upload" class="blueConfirmationButton">Import Contacts</f7-button>
  </f7-popup>
</template>


<script>
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'

export default {
  name: 'AddContact',
  components: {
    'page-nav-bar': pageNavBar
  },
  data: () => {
    return {
      alias: '',
      username: '',
      iban: '',
      label: ''
    }
  },
  created () {

  },
  mounted () {

  },
  beforeDestroy () {

  },
  methods: {
    addContact () {
      let that = this
      this.$engine.contacts
        .create({login: this.alias, name: this.username, iban: this.iban, label: this.label})
        .then(() => {
          that.$bus.$emit('refresh-cache-contacts')
          that.$f7.alert('Contact correctly added', 'Success', function () {
            that.$f7.closeModal()
          })
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
    }
  }
}
</script>
